/*
 * @Author: Alex
 * @Date: 2023-05-11 15:43:04
 * @Description: TODO：
 */
import RenderEvent from 'ol/render/Event'
import { Fill, Stroke, Style } from 'ol/style'
import { Map } from 'ol'
import ScaleLine from 'ol/control/ScaleLine'
import { ElementHelper, getMapCanvas } from '../mapUtil'
import { unByKey } from 'ol/Observable'
import { EventsKey } from 'ol/events'
import { Color, asString } from 'ol/color'
import { warn } from '../console'

export default class CanvasScaleControl extends ScaleLine {
  private _scaleHeight: number

  /**
   * 监听
   */
  private _listener: EventsKey | null = null

  private _olscale: any

  private _strokeColor = '#000'

  private _strokeWidth = 2

  private _fillColor = '#fff'

  private _font = '10px Arial'

  private _fontStrokeColor!: string

  private _fontStrokeWidth = 3

  private _fontFillColor!: string

  constructor(options?: { style?: Style }) {
    super({})
    this.element.classList.add('ol-canvas-control')
    this._scaleHeight = 6
    if (!options) {
      options = {}
    }
    if (!options.style) options.style = new Style()
    this.setStyle(options.style)
  }

  /**
   * Remove the control from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {ol_Map} map Map.
   * @api stable
   */
  setMap(map: Map) {
    getMapCanvas(map)
    const oldmap = this.getMap()
    if (this._listener) unByKey(this._listener)
    this._listener = null

    super.setMap(map)
    if (oldmap) {
      try {
        oldmap.renderSync()
      } catch (e) {
        /* ok */
      }
    }
    let start = true

    // Add postcompose on the map
    if (map) {
      this._listener = map.on('postcompose', e => {
        if (start) {
          setTimeout(() => {
            start = false
            this.drawScale(e)
          }, 20)
        } else {
          this.drawScale(e)
        }
      })
    }

    // Hide the default DOM element
    this.element.style.visibility = 'hidden'
    this._olscale = this.element.querySelector('.ol-scale-line-inner')
  }
  /**
   * Change the control style
   * @param {ol_style_Style} style
   */
  setStyle(style: Style) {
    let stroke: Stroke | null = style.getStroke()
    this._strokeColor = stroke ? asString(stroke.getColor() as Color) : '#000'
    this._strokeWidth = stroke?.getWidth() ?? 2

    let fill: Fill | null = style.getFill()
    this._fillColor = fill ? asString(fill.getColor() as Color) : '#fff'

    const text = style.getText()
    this._font = text ? text.getFont() ?? '10px Arial' : '10px Arial'
    stroke = text ? text.getStroke() : null
    fill = text ? text.getFill() : null
    this._fontStrokeColor = stroke
      ? asString(stroke.getColor() as Color)
      : this._fillColor
    this._fontStrokeWidth = stroke?.getWidth() ?? 3
    this._fontFillColor = fill
      ? asString(fill.getColor() as Color)
      : this._strokeColor
    // refresh
    if (this.getMap()) this.getMap()?.render()
  }

  private drawScale(e: RenderEvent): void {
    if (
      this.element.style.visibility !== 'hidden' ||
      ElementHelper.getStyle(this.element, 'display') === 'none'
    )
      return
    const ctx = this.getContext(e)
    if (!ctx) {
      warn('[canvas-scale] ctx is null')
      return
    }

    // Get size of the scale div
    const scalewidth = parseInt(this._olscale.style.width)
    if (!scalewidth) {
      warn('[canvas-scale] scale width is ', scalewidth)
      return
    }
    const text = this._olscale.textContent
    const position = {
      left: this.element.offsetLeft,
      top: this.element.offsetTop
    }
    // Retina device
    const ratio = e.frameState?.pixelRatio ?? 1
    ctx.save()
    ctx.scale(ratio, ratio)

    // On top
    position.top += this.element.clientHeight - this._scaleHeight

    // Draw scale text
    ctx.beginPath()
    ctx.strokeStyle = this._fontStrokeColor
    ctx.fillStyle = this._fontFillColor
    ctx.lineWidth = this._fontStrokeWidth
    ctx.textAlign = 'center'
    ctx.textBaseline = 'bottom'
    ctx.font = this._font
    ctx.lineJoin = 'round'
    ctx.strokeText(text, position.left + scalewidth / 2, position.top)
    ctx.fillText(text, position.left + scalewidth / 2, position.top)
    ctx.closePath()

    // Draw scale bar
    position.top += 2
    ctx.lineWidth = this._strokeWidth
    ctx.strokeStyle = this._strokeColor
    let max = 4
    let n = parseInt(text)
    while (n % 10 === 0) n /= 10
    if (n % 5 === 0) max = 5
    for (let i = 0; i < max; i++) {
      ctx.beginPath()
      ctx.fillStyle = i % 2 ? this._fillColor : this._strokeColor
      ctx.rect(
        position.left + (i * scalewidth) / max,
        position.top,
        scalewidth / max,
        this._scaleHeight
      )
      ctx.stroke()
      ctx.fill()
      ctx.closePath()
    }
    ctx.restore()
  }

  /** Get map Canvas
   * @private
   */
  private getContext(e: any): CanvasRenderingContext2D | null {
    let ctx = e.context
    if (!ctx && this.getMap()) {
      const c = this.getMap()
        ?.getViewport()
        .getElementsByClassName('ol-fixedoverlay')[0]
      ctx = c ? (c as HTMLCanvasElement).getContext('2d') : null
    }
    return ctx
  }
}
